<!-- Контрагенты -->
<template>
  <li
    v-if="canSeePage('counterparties')"
    class="nav-item"
    role="button"
    tabindex="0"
    @click="navigate($event, 'Counterparties')"
    @mouseup="handleMiddleClick($event, 'Counterparties')"
    @contextmenu.prevent.stop="
      showContextMenu($event, 'Counterparties')
    "
    :class="{ active: activeItem === 'counterparties' }"
    :title="collapsed ? 'Контрагенты' : ''"
  >
    <div class="link-icon_box">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
        fill="#00bfa5"
        width="24"
        height="24"
      >
        <path
          d="M 6,1 C 5,1 4,2.02 4,3 l 0,1 -0.75,0 0,9 7.5,0 0,-9 L 10,4 10,3 C 10,2 8.99,1 8,1 z m 0.5,1.25 1,0 c 0.86,0 1.25,0.6 1.25,1.25 l 0,0.5 -3.5,0 0,-0.5 C 5.25,2.87 5.55,2.25 6.5,2.25 z M 2,4 C 0.64,4 0,4.64 0,6 l 0,5 c 0,1.36 0.75,2 2,2 z m 10,0 0,9 c 1.25,0 2,-0.75 2,-2 L 14,6 C 14,4.68 13.38,4 12,4 z"
        />
      </svg>
    </div>
    <span v-if="!collapsed" class="nav-link">Контрагенты</span>
  </li>
</template>

<script>
import {
  useSidebarItem,
  sidebarItemProps,
} from "@/composables/useSidebarItem";

export default {
  name: "CounterpartiesItem",
  props: sidebarItemProps,
  emits: ["navigate", "middle-click", "context-menu"],
  setup(props, { emit }) {
    return useSidebarItem(emit);
  },
};
</script>
